import { render, staticRenderFns } from "./EFormEstrutura.vue?vue&type=template&id=ee674478"
import script from "./EFormEstrutura.vue?vue&type=script&lang=js"
export * from "./EFormEstrutura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports